import type Meta from '@/shared/lib/types/meta';
import type { PatientsData } from '@/shared/lib/types/patients';
import type { TagType } from '@/shared/lib/types/tag';
import { gql } from '@apollo/client';

export type AccountList = {
  id: string;
  name: string;
  description: string;
  isShared: boolean;
  accounts: Partial<PatientsData>[];
};

export type TaggedAccountsResponse = {
  getTaggedAccounts: {
    accounts: {
      id: string;
      truentityId: string;
      birthDate: string;
      phone: string;
      user: {
        firstName: string;
        lastName: string;
      };
      tags: TagType[];
    }[];
    meta: Meta;
  };
};

export type AccountListsResponse = {
  getAllAccountLists: {
    accountLists: AccountList[];
    meta: {
      totalPages: number;
      totalCount: number;
    };
  };
};

export type StarOrUnstarAccountsResponse = {
  starOrUnstarAccounts: {
    status: string;
    message: string;
  };
};

export const GET_ALL_ACCOUNTS_LIST = gql`
  query GetAllAccountLists($pageNum: Int, $pageSize: Int) {
    getAllAccountLists(pageNum: $pageNum, pageSize: $pageSize) {
      accountLists {
        id
        name
        description
        isShared
        accounts {
          id
          truentityId
          phone
          birthDate
          user {
            firstName
            middleName
            lastName
          }
        }
      }
    }
  }
`;

export const GET_TAGGED_ACCOUNTS = gql`
  query GetTaggedAccounts($pageNum: Int, $pageSize: Int, $tagIds: [ID!]!) {
    getTaggedAccounts(pageNum: $pageNum, pageSize: $pageSize, tagIds: $tagIds) {
      accounts {
        id
        truentityId
        birthDate
        phone
        user {
          firstName
          lastName
        }
        tags {
          id
          name
          colorCode
        }
      }
      meta {
        totalCount
        totalPages
        currentPage
        perPage
      }
    }
  }
`;

export const CREATE_ACCOUNT_LIST = gql`
  mutation CreateAccountList($name: String!, $description: String, $isShared: Boolean) {
    createAccountList(name: $name, description: $description, isShared: $isShared) {
      status
      message
    }
  }
`;

export const REMOVE_ACCOUNT_LIST = gql`
  mutation RemoveAccountList($accountListId: ID!) {
    removeAccountList(accountListId: $accountListId) {
      status
      message
    }
  }
`;

export const ADD_ACCOUNT_TO_ACCOUNT_LIST = gql`
  mutation AddAccountsToAccountList($accountListId: ID!, $truentityIds: [ID!]!) {
    addAccountsToAccountList(accountListId: $accountListId, truentityIds: $truentityIds) {
      status
      message
    }
  }
`;

export const REMOVE_ACCOUNT_FROM_ACCOUNT_LIST = gql`
  mutation RemoveAccountsFromAccountList($accountListId: ID!, $truentityIds: [ID!]!) {
    removeAccountsFromAccountList(accountListId: $accountListId, truentityIds: $truentityIds) {
      status
      message
    }
  }
`;

export const STAR_OR_UNSTAR_ACCOUNTS = gql`
  mutation StarOrUnstarAccounts($truentityId: String!, $action: String!) {
    starOrUnstarAccounts(truentityId: $truentityId, action: $action) {
      status
      message
    }
  }
`;
